(() => {
  const initSlider = (section) => {
    if (!section) return;
    const slider = section.querySelector(".js-slider-logos");
    if (!slider) return;
    const swiperThumbsElement = slider.querySelector(".slider-with-thumbs");
    const swiperThumbsTopElement = slider.querySelector(
      ".slider-with-thumbs-top"
    );
    if (!swiperThumbsElement || !swiperThumbsTopElement) return;
    const gap = Number(slider.dataset.gap) || 10;
    const isAutoplay = slider.dataset.autoplay === "true" ? true : false;
    const autoplayDelay = Number(slider.dataset.autoplayDelay) || 5000;
    const swiperThumbs = new Swiper(swiperThumbsElement, {
      spaceBetween: gap,
      slidesPerView: "auto",
      freeMode: false,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
    });
    new Swiper(swiperThumbsTopElement, {
      spaceBetween: 10,
      speed: 1000,
      loop: true,
      navigation: {
        nextEl: slider.querySelector(".slider-with-thumbs-button--next"),
      },
      thumbs: {
        swiper: swiperThumbs,
      },
      autoplay: isAutoplay ? { delay: autoplayDelay } : false,
      on: {
        slideChange: function () {
          swiperThumbs.slideTo(this.realIndex);
        },
      },
    });
  };
  initSlider(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", function (section) {
    initSlider(section.target);
  });
})();
